import SchoolGroupInformation from './SchoolGroupInformation.component';

export default SchoolGroupInformation;
